import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface Profile {
	id: number;
	name: string;
	email: string;
	phone: string;
	barcode: string;
	status: string;
	plan: string;
	zipCode: string;
	emailOptIn: boolean;
	phoneOptIn: boolean;
}

interface ProfileState {
	profilesListing: Profile[];
	searchQuery: string;
}

const ProfileListingSlice = createSlice({
	name: "profileListing",
	initialState: {
		profilesListing: [] as Profile[],
	} as ProfileState,
	reducers: {
		setProfiles(state, action: PayloadAction<Profile[]>) {
			state.profilesListing = action.payload;
		},
		addProfile(state, action: PayloadAction<Profile>) {
			state.profilesListing.push(action.payload);
		},
		updateProfile(state, action: PayloadAction<Profile>) {
			state.profilesListing = state.profilesListing.map((profile) =>
				profile.id === action.payload.id ? action.payload : profile
			);
		},
		deleteProfile(state) {
			state.profilesListing = [];
		},
	},
});

export const {setProfiles, addProfile, updateProfile, deleteProfile} =
	ProfileListingSlice.actions;

export default ProfileListingSlice.reducer;
